'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _params3 = require('../../utils/params');

var _promise = require('../../utils/promise');

var _client = require('../../utils/client');

var _authentication = require('../../api/authentication');

var _localStorage = require('constructicon/lib/localStorage');

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProviderOauthButton = function (_Component) {
  _inherits(ProviderOauthButton, _Component);

  function ProviderOauthButton(props) {
    _classCallCheck(this, ProviderOauthButton);

    var _this = _possibleConstructorReturn(this, (ProviderOauthButton.__proto__ || Object.getPrototypeOf(ProviderOauthButton)).call(this, props));

    _this.handleAuth = _this.handleAuth.bind(_this);
    _this.handleSuccess = _this.handleSuccess.bind(_this);
    _this.providerUrl = _this.providerUrl.bind(_this);

    _this.state = {
      status: 'empty',
      success: false
    };
    return _this;
  }

  _createClass(ProviderOauthButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.localStoragePoll);
      clearInterval(this.isPopupClosed);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onSuccess = _props.onSuccess,
          popup = _props.popup,
          provider = _props.provider,
          redirectUri = _props.redirectUri,
          useLocalStorage = _props.useLocalStorage;


      var data = (0, _params3.parseUrlParams)();

      if (popup && typeof onSuccess === 'function') {
        if (useLocalStorage) {
          var key = 'app-oauth-state-' + provider;

          if (data.access_token || data.code) {
            (0, _localStorage.setLocalStorageItem)(key, data);
            window.opener && window.close();
          } else {
            (0, _localStorage.setLocalStorageItem)(key, {});

            this.localStoragePoll = setInterval(function () {
              var oauthState = (0, _localStorage.getLocalStorageItem)(key);
              if (oauthState.access_token) {
                clearInterval(_this2.localStoragePoll);
                return _this2.handleSuccess(oauthState);
              }
            }, 1000);
          }
        } else {
          var _window = window,
              addEventListener = _window.addEventListener;

          var validSourceOrigin = redirectUri && new _urlParse2.default(redirectUri).origin;

          addEventListener('message', function (event) {
            var data = event.data;
            var isValid = event.origin === validSourceOrigin || data === 'strava connected' || data === 'fitbit connected';

            if (isValid && !_this2.state.success) {
              return _this2.handleSuccess(data);
            }
          }, false);
        }
      }

      if (data.access_token || data.code) {
        return this.handleSuccess(data);
      }
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(data) {
      var _this3 = this;

      var _props2 = this.props,
          onSuccess = _props2.onSuccess,
          provider = _props2.provider;


      var handleAuthSuccess = function handleAuthSuccess(data) {
        return Promise.resolve().then(function () {
          return _this3.setState({ status: 'fetching' });
        }).then(function () {
          return (0, _promise.toPromise)(onSuccess)(data);
        }).then(function () {
          return _this3.setState({ status: 'fetched' });
        }).catch(function () {
          return _this3.setState({ status: 'empty', success: false });
        });
      };

      if (['justgiving', 'facebook'].indexOf(provider) > -1) {
        Promise.resolve().then(function () {
          return _this3.setState({ success: true });
        }).then(function () {
          return (0, _authentication.connectToken)(data);
        }).then(handleAuthSuccess).catch(function (error) {
          _this3.setState({ status: 'empty' });
          return Promise.reject(error);
        });
      } else {
        this.setState({ success: true });
        return handleAuthSuccess(data);
      }
    }
  }, {
    key: 'handleAuth',
    value: function handleAuth() {
      var _this4 = this;

      var _props3 = this.props,
          popupWindowFeatures = _props3.popupWindowFeatures,
          provider = _props3.provider,
          onClose = _props3.onClose;


      var popupWindow = window.open(this.providerUrl(), provider + 'Auth', popupWindowFeatures);

      this.setState({ status: 'loading' });

      this.isPopupClosed = setInterval(function () {
        if (popupWindow.closed) {
          var success = _this4.state.success;

          clearInterval(_this4.isPopupClosed);
          _this4.setState({ status: success ? 'loading' : 'empty' });

          if (typeof onClose === 'function') {
            return onClose(popupWindow);
          }
        }
      }, 500);
    }
  }, {
    key: 'providerUrl',
    value: function providerUrl() {
      var _props4 = this.props,
          clientId = _props4.clientId,
          homeUrl = _props4.homeUrl,
          provider = _props4.provider,
          redirectUri = _props4.redirectUri,
          state = _props4.state,
          token = _props4.token,
          _props4$authParams = _props4.authParams,
          authParams = _props4$authParams === undefined ? {} : _props4$authParams;


      if (['justgiving', 'facebook'].indexOf(provider) > -1) {
        var params = _extends({
          client_id: clientId,
          redirect_uri: redirectUri,
          response_type: 'code',
          state: homeUrl && encodeURIComponent('home=' + homeUrl),
          acr_values: provider === 'facebook' ? 'encodedOptions:' + (0, _params3.base64EncodeParams)({ forceFacebook: true }) : undefined
        }, authParams);

        var urlParams = Object.keys(params).map(function (key) {
          return key + '=' + encodeURIComponent(params[key]);
        }).join('&');

        var baseURL = (0, _client.getBaseURL)().replace('api', 'identity');

        return baseURL + '/connect/authorize?' + urlParams + '&scope=openid+profile+email+account+fundraise+offline_access';
      } else if (provider === 'strava') {
        var _baseURL = 'https://www.strava.com/oauth/authorize';

        var _params = _extends({
          client_id: clientId,
          redirect_uri: redirectUri,
          response_type: 'code',
          scope: 'read,activity:read',
          state: state || token
        }, authParams);

        var _urlParams = Object.keys(_params).map(function (key) {
          return key + '=' + encodeURIComponent(_params[key]);
        }).join('&');

        return _baseURL + '?' + _urlParams;
      } else if (provider === 'fitbit') {
        var _baseURL2 = 'https://www.fitbit.com/oauth2/authorize';

        var _params2 = _extends({
          client_id: clientId,
          redirect_uri: redirectUri,
          response_type: 'code',
          scope: 'activity heartrate location nutrition profile settings sleep social weight',
          state: state
        }, authParams);

        var _urlParams2 = Object.keys(_params2).map(function (key) {
          return key + '=' + encodeURIComponent(_params2[key]);
        }).join('&');

        return _baseURL2 + '?' + _urlParams2;
      } else {
        throw new Error('JustGiving does not support ' + provider + ' authentication');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props5 = this.props,
          label = _props5.label,
          popup = _props5.popup,
          provider = _props5.provider,
          props = _objectWithoutProperties(_props5, ['label', 'popup', 'provider']);

      var status = this.state.status;

      var isLoading = ['loading', 'fetching'].indexOf(status) > -1;
      var icon = isLoading ? 'loading' : status === 'fetched' ? 'check' : provider;

      var actionProps = popup ? {
        onClick: function onClick(e) {
          return _this5.handleAuth();
        }
      } : {
        href: this.providerUrl(),
        tag: 'a'
      };

      return _react2.default.createElement(
        _button2.default,
        _extends({
          'aria-label': label,
          background: provider,
          disabled: isLoading
        }, actionProps, (0, _omit2.default)(props, ['authParams', 'clientId', 'homeUrl', 'onClose', 'onSuccess', 'popupWindowFeatures', 'redirectUri', 'token', 'useLocalStorage'])),
        _react2.default.createElement(_icon2.default, { name: icon, spin: isLoading, size: 1.5 }),
        _react2.default.createElement(
          'span',
          null,
          isLoading ? status === 'fetching' ? 'Fetching data...' : 'Connecting...' : label
        )
      );
    }
  }]);

  return ProviderOauthButton;
}(_react.Component);

ProviderOauthButton.propTypes = {
  /**
   * The OAuthApplication client ID
   */
  clientId: _propTypes2.default.string.isRequired,

  /**
   * Button label
   */
  label: _propTypes2.default.any,

  /**
   * The onClose event handler if popup is closed
   */
  onClose: _propTypes2.default.func,

  /**
   * The onSuccess event handler if using a popup
   */
  onSuccess: _propTypes2.default.func,

  /**
   * Whether to handle with a popup
   */
  popup: _propTypes2.default.bool,

  /**
   * The features for the popup window (see https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Window_features)
   */
  popupWindowFeatures: _propTypes2.default.string,

  /**
   * The third-party provider to connect with
   */
  provider: _propTypes2.default.oneOf(['strava', 'facebook', 'fitbit', 'justgiving']),

  /**
   * A valid return_to url for the specified OAuthApplication
   */
  redirectUri: _propTypes2.default.string.isRequired,

  /**
   * The token of the existing user (used when connecting JG account to Strava)
   */
  token: _propTypes2.default.string,

  /**
   * The slug of the existing user's page (used when connecting JG account to Fitbit)
   */
  slug: _propTypes2.default.string,

  /**
   * The state includes semi-colon seperated string containing token, page slug, and measurement metric (required when connecting JG account to Fitbit)
   */
  state: _propTypes2.default.string,

  /**
   * Home URl that our oauth handler (oauth.blackbaud-sites.com) will redirect to
   */
  homeUrl: _propTypes2.default.string,

  /**
   * URL Params to be passed to provider
   */
  authParams: _propTypes2.default.object
};

ProviderOauthButton.defaultProps = {
  label: 'Login with JustGiving',
  popup: true,
  popupWindowFeatures: 'width=600,height=900,status=1',
  provider: 'justgiving'
};

exports.default = ProviderOauthButton;